module.exports = __webpack_public_path__ + "static/img/animales_07.2f0e5a38.jpg";